export * from "ce/api/ApplicationApi";
import { ApplicationApi as CE_ApplicationApi } from "ce/api/ApplicationApi";

class ApplicationApi extends CE_ApplicationApi { }

export default ApplicationApi;
